
import Logger from "../lib/logger";

class ThemeHeader {

  // Logic
  // ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	/**
	 * Class static initialization block
	 */
	constructor(dom) {

		this.NAME = 'ThemeHeader';
		Logger.info(`${this.NAME} > init`);

		const self = this;

		// Assign variables
		this.dom = dom;
		this.hamburgerDom = this.dom.querySelector('[data-theme-header-hamburger]');
		this.hamburgerDomActiveClass = 'theme-header__hamburger--active';

		this.navDom = this.dom.querySelector('[data-theme-header-nav]')
		this.navActiveClass = 'theme-header__nav--active';

		this.initHamburger();
	}

	/**
	 * Initialize the hamburger
	 **/
	initHamburger() {
		Logger.info(`${this.NAME} > initHamburger`);
		this.hamburgerDom.addEventListener('click', (e) => {
			e.preventDefault();
			this.hamburgerDom.classList.toggle(this.hamburgerDomActiveClass);

			if(this.hamburgerDom.classList.contains(this.hamburgerDomActiveClass)) {
				this.navDom.classList.add(this.navActiveClass);
			} else {
				this.navDom.classList.remove(this.navActiveClass);
			}
		});
	}
}

export default ThemeHeader;
